export default __webpack_public_path__ + "static/media/09_motor_Agencias.ef3e86b9.svg";